(function () {
    'use strict';

    angular.module('doclr.patienten', ['doclr.praktijk', 'doclr.resources.api', 'ui.bootstrap'])
        .config(function ($stateProvider) {
            $stateProvider
                .state('burgers', {
                    url: '/burgers',
                    params: {
                        huidigeStatus: 'Aanvraag',
                        huidigeZoek: '',
                        huidigePage: 1
                    },
                    resolve: {
                        patientenLijst: function (Patienten, praktijkContext, $stateParams) {
                            let status = $stateParams.huidigeStatus;

                            if (!praktijkContext.patientenstopZonderLogin) {
                                status = 'AlleStatussen';
                            }

                            return Patienten.getList(praktijkContext.id, status, $stateParams.huidigeZoek, $stateParams.huidigePage);
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.html'
                        },
                        'content@burgers': {
                            templateUrl: '/partials/patientenbeheer/patientenbeheer.html',
                            controller: function ($scope
                                , $state
                                , Patienten
                                , patientenLijst
                                , userContext
                                , praktijkContext
                                , $stateParams
                                , $uibModal
                                , $rootScope
                            ) {
                                $scope.patientenLijst = patientenLijst;
                                $scope.mathLib = Math;
                                $scope.isAdminUser = userContext.admin;
                                $scope.praktijkContext = praktijkContext;
                                $rootScope.$on('$blockListChanged', () => reloadState());

                                function reloadState() {
                                    $state.go('burgers', {
                                        huidigeStatus: $scope.huidigeStatus,
                                        huidigeZoek: $scope.huidigeZoek,
                                        huidigePage: $scope.huidigePage
                                    }, {reload: true});
                                }

                                $scope.volgendePagina = function () {
                                    $scope.huidigePage++;
                                    reloadState();
                                };

                                $scope.vorigePagina = function () {
                                    $scope.huidigePage--;
                                    reloadState();
                                };

                                function toonPatientInfoAanpassen(patient) {
                                    Patienten.getPatientGegevens(praktijkContext.id, patient.id).then(function (patientGegevens) {
                                        $uibModal.open({
                                            templateUrl: '/partials/patientenbeheer/patientinfoaanpassen.html',
                                            controller: function ($scope, $uibModalInstance) {
                                                $scope.patientGegevens = patientGegevens;
                                                $scope.annuleren = function () {
                                                    toonPatientInfo(patient);
                                                    $uibModalInstance.close();
                                                };
                                                $scope.bewaren = function () {
                                                    Patienten.updatePatientGegevens(praktijkContext.id, $scope.patientGegevens).then(function () {
                                                        toonPatientInfo(patient);
                                                        $uibModalInstance.close();
                                                    });
                                                };
                                            },
                                            backdrop: 'static'
                                        });
                                    });
                                }

                                function toonPatientInfo(patient) {
                                    Patienten.getPatientInfo(praktijkContext.id, patient.id).then(function (patientInfo) {
                                        $uibModal.open({
                                            templateUrl: '/partials/patientenbeheer/patientinfomodal.html',
                                            controller: function ($scope, $uibModalInstance, praktijkContext) {
                                                $scope.patientInfo = patientInfo;
                                                $scope.praktijkContext = praktijkContext;
                                                $scope.patientAanpassen = function () {
                                                    toonPatientInfoAanpassen(patient);
                                                    $uibModalInstance.close();
                                                };
                                            }
                                        });
                                    });
                                }

                                $scope.toonPatient = toonPatientInfo;

                                $scope.updateStatus = function (patient, status) {
                                    $scope.confirmmodal = {
                                        title: doclrVertaal.instant('patientenbeheer.change.status.confirmmodal.title'),
                                        question: doclrVertaal.instant('patientenbeheer.change.status.confirmmodal.question') + ' ' + doclrVertaal.translateEnum(status, 'patientAanvraagStatus') + '?'
                                    };

                                    const modalInstance = $uibModal.open({
                                        templateUrl: '/partials/components/confirmmodal.html',
                                        scope: $scope
                                    });

                                    modalInstance.result.then(function () {
                                        Patienten.updateStatus(praktijkContext.id, patient.id, status).then(function () {
                                            reloadState();
                                        });
                                    });
                                };

                                $scope.huidigeStatus = $stateParams.huidigeStatus;
                                $scope.huidigeZoek = $stateParams.huidigeZoek;
                                $scope.huidigePage = $stateParams.huidigePage;
                            }
                        },
                        'sidebar@burgers': {
                            templateUrl: '/partials/patientenbeheer/patientenbeheer.sidebar.html',
                            controller: function ($scope, $state, $stateParams, praktijkContext) {
                                $scope.praktijkContext = praktijkContext;

                                function reloadState() {
                                    $state.go('burgers', {
                                            huidigeStatus: $scope.huidigeStatus
                                            , huidigeZoek: $scope.huidigeZoek, huidigePage: $scope.huidigePage
                                        }
                                        , {reload: true});
                                }

                                $scope.createNew = function () {
                                    $state.go('nieuweburger');
                                };

                                $scope.isFilterStatusActief = function (statusnaam) {
                                    return $scope.huidigeStatus === statusnaam;
                                };

                                $scope.filterOpStatus = function (statusnaam) {
                                    $scope.huidigeStatus = statusnaam;
                                    $scope.huidigePage = 1;
                                    reloadState();
                                };

                                $scope.zoek = function () {
                                    $scope.huidigePage = 1;
                                    reloadState();
                                };

                                $scope.onZoekType = function ($event) {
                                    const keyCode = $event.which || $event.keyCode;
                                    if (keyCode === 13) {
                                        $scope.huidigePage = 1;
                                        reloadState();
                                    }
                                };

                                $scope.statussen = ['AlleStatussen', 'Aanvraag', 'Aanvaard', 'Geweigerd', 'Ingetrokken'];
                                $scope.huidigeStatus = $stateParams.huidigeStatus;
                                $scope.huidigeZoek = $stateParams.huidigeZoek;
                                $scope.huidigePage = $stateParams.huidigePage;
                            }
                        }
                    }
                });
        });
})();